module.exports = __webpack_public_path__ + "static/img/rank_52.96b9570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_52.png
// module id = Till
// module chunks = 0